import React, { useEffect } from 'react';
import { toast } from 'sonner';
import { CONSTANTS } from '../utils/constants';
export const PurchasePopup: React.FC = () => {
  useEffect(() => {
    let timeoutId: number;
    const showRandomPurchase = () => {
      const randomBuyer = CONSTANTS.PURCHASE_NAMES[Math.floor(Math.random() * CONSTANTS.PURCHASE_NAMES.length)];
      toast.custom(t => <div className="bg-white rounded-lg shadow-lg border border-gray-100 p-4 flex items-center space-x-4 max-w-sm animate-in slide-in-from-bottom-5" data-id="element-245">
            <div className="flex-shrink-0 w-12 h-12 rounded bg-blue-50 overflow-hidden border border-gray-200" data-id="element-246">
              <img src={CONSTANTS.PRODUCT_IMAGE} alt="Product thumbnail" className="w-full h-full object-cover object-center" data-id="element-247" />
            </div>
            <div data-id="element-248">
              <p className="text-sm text-gray-800" data-id="element-249">
                <span className="font-bold" data-id="element-250">{randomBuyer.name}</span> de{' '}
                {randomBuyer.city}, Argentina
              </p>
              <p className="text-xs text-green-600 font-medium mt-1" data-id="element-251">
                acaba de comprar este producto
              </p>
            </div>
          </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
      // Schedule next popup between 15 and 30 seconds
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      timeoutId = window.setTimeout(showRandomPurchase, nextDelay);
    };
    // First popup at 10 seconds
    timeoutId = window.setTimeout(showRandomPurchase, 10000);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, []);
  return null; // This component just handles the logic for Sonner toasts
};